import { useJsApiLoader } from '@react-google-maps/api';

import { globalSettings } from '../config/baseSettings';

export const useGoogleMapLoader = () => useJsApiLoader(globalSettings);
